// extracted by mini-css-extract-plugin
module.exports = {"social-media":"social-links_social-media__lx7Qt","light":"social-links_light__srg_7","link":"social-links_link__okfGD","dark":"social-links_dark__qnrGP"};